// src/plugins/idleTimer.js

let idleTimer
let timeout = 240 * 60 * 1000 // Default 240 minutes
const events = ['mousemove', 'keydown', 'click', 'scroll']

const resetTimer = () => {
  localStorage.setItem('lastActivity', Date.now().toString())
  clearTimeout(idleTimer)
  startTimer()
}

const checkIdleTime = () => {
  const lastActivity = parseInt(localStorage.getItem('lastActivity') || '0', 10)
  if (Date.now() - lastActivity > timeout) {
    localStorage.removeItem('loggedIn')
    stopTimer()
    window.location.href = '/login'
  } else {
    startTimer()
  }
}

const startTimer = () => {
  clearTimeout(idleTimer)
  idleTimer = setTimeout(checkIdleTime, timeout)
}

const stopTimer = () => {
  clearTimeout(idleTimer)
  events.forEach((event) => window.removeEventListener(event, resetTimer))
}

const setIdleTimeout = (newTimeout) => {
  timeout = newTimeout * 60 * 1000 // Convert minutes to ms
  resetTimer() // restart with new timeout
}

// Vue Plugin Installation
const idleTimerPlugin = {
  install(app) {
    // Initialize lastActivity on app start
    if (!localStorage.getItem('lastActivity')) {
      localStorage.setItem('lastActivity', Date.now().toString())
    }

    resetTimer() // ensures timer starts on load

    // Register event listeners
    events.forEach((event) => {
      window.addEventListener(event, resetTimer)
    })
  },
}

export { setIdleTimeout, stopTimer, resetTimer }
export default idleTimerPlugin
